import { ArrowBack, Search, ShoppingCartOutlined } from "@mui/icons-material"
import { Badge, IconButton } from "@mui/material"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

const Universalpageheader = ({ pagename, withbackicon, onshowsearch }) => {
    const navigate = useNavigate()
    const cartItems = useSelector(state => state.cartItems.data);



    return (
        <div className="pageheader">
            <div className="pageheadertitle">
                {withbackicon &&
                    <IconButton onClick={() => navigate(-1)}>
                        <ArrowBack color="secondary" />
                    </IconButton>}
                {pagename}
            </div>
            <div className="wrapheadericons">
                <IconButton onClick={onshowsearch}>
                    <Search color="secondary" />
                </IconButton>
                { }
                <IconButton onClick={() => navigate("/cart")}>
                    {cartItems?.length > 0 ?
                        <Badge badgeContent={cartItems?.length} color="primary" >
                            <ShoppingCartOutlined color="secondary" />
                        </Badge> :
                        <ShoppingCartOutlined color="secondary" />
                    }
                </IconButton>
            </div>
        </div>
    )
}

export default Universalpageheader